import { convertLatLngInterfaceToLatLng } from "../../utils"
import type { Attachment } from "../projects/projects.types"
import { AttachmentType } from "./../../models/models"
import type {
  AttachmentEditorAction,
  AttachmentEditorEditAction,
  AttachmentEditorStateAction,
  AttachmentEditorStates
} from "./attachment-editor.types"

export const ATTACHMENT_EDITOR_SET_STATE: string = "ATTACHMENT_EDITOR_SET_STATE"
export const ATTACHMENT_EDITOR_START_CREATE: string = "ATTACHMENT_EDITOR_START_CREATE"
export const ATTACHMENT_EDITOR_START_EDIT: string = "ATTACHMENT_EDITOR_START_EDIT"
export const ATTACHMENT_EDITOR_SELECT_TYPE: string = "ATTACHMENT_EDITOR_SELECT_TYPE"
export const ATTACHMENT_EDITOR_SAVE_FORM: string = "ATTACHMENT_EDITOR_SAVE_FORM"
export const ATTACHMENT_EDITOR_SELECT_LOCATION: string = "ATTACHMENT_EDITOR_SELECT_LOCATION"
export const ATTACHMENT_EDITOR_FINISH_CREATE: string = "ATTACHMENT_EDITOR_FINISH_CREATE"
export const ATTACHMENT_EDITOR_START_UPDATE: string = "ATTACHMENT_EDITOR_START_UPDATE"
export const ATTACHMENT_EDITOR_CHANGE_ATTACHMENT: string = "ATTACHMENT_EDITOR_CHANGE_ATTACHMENT"
export const ATTACHMENT_EDITOR_OPEN_DIALOG: string = "ATTACHMENT_EDITOR_OPEN_DIALOG"
export const ATTACHMENT_EDITOR_CLOSE_DIALOG: string = "ATTACHMENT_EDITOR_CLOSE_DIALOG"
export const ATTACHMENT_EDITOR_MOVE_PIN: string = "ATTACHMENT_EDITOR_MOVE_PIN"
export const ATTACHMENT_EDITOR_UPDATE_PIN_POSITION: string = "ATTACHMENT_EDITOR_UPDATE_PIN_POSITION"
export const ATTACHMENT_EDITOR_FINISH_PIN_POSITION_UPDATE: string = "ATTACHMENT_EDITOR_FINISH_PIN_POSITION_UPDATE"
export const ATTACHMENT_EDITOR_SELECT_ATTACHMENT: string = "ATTACHMENT_EDITOR_SELECT_ATTACHMENT"
export const ATTACHMENT_EDITOR_HIGHLIGHT_ATTACHMENT: string = "ATTACHMENT_EDITOR_HIGHLIGHT_ATTACHMENT"

export function attachmentEditorSetState(state: AttachmentEditorStates): AttachmentEditorStateAction {
  return { type: ATTACHMENT_EDITOR_SET_STATE, payload: state }
}

export function attachmentEditorStartCreate(attachmentCount: number): AttachmentEditorEditAction {
  return {
    type: ATTACHMENT_EDITOR_START_CREATE,
    payload: {
      id: null,
      title: "",
      description: "",
      order: attachmentCount + 1,
      location: "",
      type: null,
      pointOnMap: null
    }
  }
}

export function attachmentEditorStartEdit(attachment: Attachment): AttachmentEditorEditAction {
  return {
    type: ATTACHMENT_EDITOR_START_EDIT,
    payload: {
      id: attachment.id ? attachment.id : null,
      title: attachment.title,
      description: attachment.description,
      order: attachment.order,
      location: attachment.location ? attachment.location : "",
      type: attachment.type,
      pointOnMap: attachment.pointOnMap ? convertLatLngInterfaceToLatLng(attachment.pointOnMap) : null
    }
  }
}

export function attachmentEditorSelectType(attachmentType: AttachmentType, order: number): AttachmentEditorAction {
  return {
    type: ATTACHMENT_EDITOR_SELECT_TYPE,
    payload: createEmptyAttachment(attachmentType, order)
  }
}

export function attachmentEditorSelectAttachment(attachment?: Attachment): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_SELECT_ATTACHMENT, payload: attachment }
}

export function attachmentEditorHighlightAttachment(attachment?: Attachment): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_HIGHLIGHT_ATTACHMENT, payload: attachment }
}

export function attachmentEditorSaveForm(attachment: Attachment): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_SAVE_FORM, payload: attachment }
}

export function attachmentEditorSelectLocation(attachment: Attachment): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_SELECT_LOCATION, payload: attachment }
}

export function attachmentEditorFinishCreate(): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_FINISH_CREATE }
}

export function attachmentEditorStartUpdate(attachment: Attachment): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_START_UPDATE, payload: attachment }
}

export function attachmentEditorChangeAttachment(attachment: Attachment): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_CHANGE_ATTACHMENT, payload: attachment }
}

export function attachmentEditorOpenDialog(): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_OPEN_DIALOG }
}

export function attachmentEditorCloseDialog(): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_CLOSE_DIALOG }
}

export function attachmentEditorMovePin(attachment: Attachment): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_MOVE_PIN, payload: attachment }
}

export function attachmentEditorFinishPositionChange(): AttachmentEditorAction {
  return { type: ATTACHMENT_EDITOR_FINISH_PIN_POSITION_UPDATE }
}

function createEmptyAttachment(type: AttachmentType, order: number): Attachment {
  return {
    title: "",
    description: "",
    location: type !== AttachmentType.Note ? "" : undefined,
    type,
    order,
    isAuthorContent: false
  }
}
